// Group payments reference a group and its maker/checker by guid only. The
// dashboard resolves those into names (see the RESOLVE_OMK_PAYMENT_LABELS
// saga) and keeps them in two caches on the payment slice; these helpers read
// those caches and fall back to the raw identifier while a lookup is in flight
// or when it was not permitted.

export function groupLabel(groupLabels, guid) {
  if (!guid) return '—'
  const entry = groupLabels ? groupLabels[guid] : null
  if (!entry || !entry.group_name) return guid
  return entry.group_number
    ? `${entry.group_name} (${entry.group_number})`
    : entry.group_name
}

export function userLabel(userLabels, userId) {
  if (!userId) return '—'
  return (userLabels && userLabels[userId]) || userId
}

// The guids a payment (or a page of payments) needs resolved.
export function labelsNeededFor(payments) {
  const groupGuids = []
  const userIds = []
  ;(payments || []).forEach(function(payment) {
    if (!payment) return
    if (payment.group_guid) groupGuids.push(payment.group_guid)
    if (payment.created_by) userIds.push(payment.created_by)
    if (payment.approved_by) userIds.push(payment.approved_by)
  })
  return { groupGuids, userIds }
}
